import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate() {
        if (localStorage.getItem('bearer') && localStorage.getItem('userId') != "0") {
            // logged in so return true
            return true;
        }

        this.router.navigate(['/login']);

        // console.log(this.router.url);
        // if (!this.router.url.includes('/resetPassword') || !this.router.url.includes('/forgotPassword') || !this.router.url.includes('/register')) {

        // } else {
        //     this.router.navigate(['/login']);
        // }

        // not logged in so redirect to login page with the return url
        // this.router.navigate(['/login']);
        return false;
    }
}
